import ListingBedBathParking from './ListingBedBathSqftLabels';
export default ListingBedBathParking;